import { Grid } from "antd";
import { useLayout } from "../../context/LayoutContext";
import ContentWrapper from "../../layouts/components/ContentWrapper";
import { ChangePassword, ProfileEditor } from "./components";
import styles from "./styleModule";

const Profile: React.FC = () => {
  const { useBreakpoint } = Grid;
  const { getHeaderHeight } = useLayout();
  const screens = useBreakpoint();
  return (
    <ContentWrapper>
      <div
        className={`${styles.container} ${screens.md ? "" : styles.small}`}
        style={
          {
            gap: screens.xs ? "4px" : "24px",
            "--marginTop": getHeaderHeight(),
          } as React.CSSProperties
        }
      >
        <ProfileEditor />
        <ChangePassword />
      </div>
    </ContentWrapper>
  );
};

export default Profile;
